import React, { Component } from 'react'
import {
  Link
} from 'react-router-dom'

class Inheritance extends Component {
  renderInheritance() {
    const inheritanceChain = []
    let currentClass = this.props.class
    let currentClassName = this.props.className
    let parent = this.props.parent

    while (currentClass.inherited && currentClass.inherited !== currentClassName) {
      inheritanceChain.push(currentClass.inherited)
      currentClass = parent.classes[currentClass.inherited]
      currentClassName = currentClass.inherited
    }

    return inheritanceChain.reverse().map((klass) => {
      const url = `${window.location.pathname.replace(this.props.className, klass)}`
      return (
        <div key={klass}>
          <Link to={url}>
            {klass}
          </Link>
        </div>
      )
    })
  }

  render() {
    const inheritance = this.renderInheritance()

    return (
      <div>
        <h3>Inheritance</h3>
        {inheritance}
      </div>
    )
  }
}

export default Inheritance



// WEBPACK FOOTER //
// ./src/Inheritance.js